"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Defines possible partial collection view crawling directions.
 */
var CrawlingDirection;
(function (CrawlingDirection) {
    /**
     * Defines a forward direction that consumes hydra:next link.
     * @enum
     */
    CrawlingDirection[CrawlingDirection["forward"] = 0] = "forward";
    /**
     * Defines a forward direction that consumes hydra:previous link.
     * @enum
     */
    CrawlingDirection[CrawlingDirection["backward"] = 1] = "backward";
})(CrawlingDirection = exports.CrawlingDirection || (exports.CrawlingDirection = {}));
/**
 * Provides capability of crawling through partial collection views.
 */
class PartialCollectionCrawler {
    constructor(collection) {
        this.collection = collection;
    }
    /**
     * Creates a new instance of the {@link PartialCollectionCrawler} from a given partial collection view.
     * @param {ICollection} collection Partial collection view to start with.
     * @returns {PartialCollectionCrawler}
     */
    static from(collection) {
        return new PartialCollectionCrawler(collection);
    }
    /**
     * Crawls partial collection views starting with a given one.
     * @param {ICrawlingOptions} options Crawling options.
     * @returns {Promise<Iterable<IResource>>}
     */
    async getMembers(options) {
        options = options || {};
        const result = [];
        const memberLimit = options.memberLimit || Number.MAX_SAFE_INTEGER;
        const iterator = this.collection.getIterator();
        if (this.addWithLimitReached(result, this.collection.members, memberLimit) || iterator === null) {
            return result;
        }
        const visitedPages = [this.collection.view.iri];
        let requests = 0;
        do {
            let term = options.direction === CrawlingDirection.backward ? "Previous" : "Next";
            let link = iterator[`${term.toLowerCase()}PartIri`];
            let furtherPart = iterator[`get${term}Part`];
            if (!link && !!options.rewind) {
                term = options.direction === CrawlingDirection.backward ? "Last" : "First";
                link = iterator[`${term.toLowerCase()}PartIri`];
                furtherPart = iterator[`get${term}Part`];
            }
            if (!link || visitedPages.indexOf(link) !== -1) {
                break;
            }
            const part = await furtherPart();
            requests++;
            visitedPages.push(iterator.currentPartIri);
            this.addWithLimitReached(result, part, memberLimit);
        } while (requests < (options.requestLimit || Number.MAX_SAFE_INTEGER) && result.length < memberLimit);
        return result;
    }
    addWithLimitReached(result, part, memberLimit) {
        for (const item of part) {
            result.push(item);
            if (result.length >= memberLimit) {
                return true;
            }
        }
        return false;
    }
}
exports.default = PartialCollectionCrawler;
//# sourceMappingURL=PartialCollectionCrawler.js.map